import React from 'react';
import AppLayout from '../components/layout/AppLayout';
import PageHeader from '../components/ui/PageHeader';
import EmptyState from '../components/ui/EmptyState';
import { FiClock } from 'react-icons/fi';

export default function ComingSoon({ title = 'Coming soon', module }) {
  return (
    <AppLayout title={title} breadcrumb={module || title}>
      <PageHeader title={title} description="This module is being implemented." />
      <div className="rounded-lg border border-slate-200 bg-white shadow-card">
        <EmptyState
          icon={FiClock}
          title="Under construction"
          description={`The ${module || title} module will appear here.`}
        />
      </div>
    </AppLayout>
  );
}
